import React from "react";
import TableAutoComponent from "../../components/complex/crud/TableAutoComponent";
import FilterComponent from "../../components/complex/crud/FilterComponent";
import generateFilterConfigs from "../../utils/FilterConfigGenerator";
import generateTableConfigs from "../../utils/TableConfigGenerator";

import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { Paginator } from "primereact/paginator";

import useSelectorDialogControl from "../../custom_hooks/complex/useSelectorDialogControl";

const title = "Product";
const apiName = "masterdata/product";
const orderBy = "id";
const orderMethod = "ASC";
const additionalParams = {};

const customColumns = [];

const configs = [
  // add_configs
  {
    name: "Product Display",
    field: "product_display_id",
    type: "object",
    object_name: "data_product_display",
    object_field: "name",
    editor: true,
    table: false,
    filter: true,
  },
  {
    name: "Product  Category",
    field: "product_category_id",
    type: "object",
    object_name: "data_product_category",
    object_field: "name",
    editor: true,
    table: true,
    filter: true,
  },
  {
    name: "Code",
    field: "code",
    type: "text_plain",
    table: true,
    filter: true,
    editor: true,
    object_name: "",
    object_field: "",
  },
  {
    name: "Name",
    field: "name",
    type: "text_plain",
    table: true,
    filter: true,
    editor: true,
    object_name: "",
    object_field: "",
  },
  {
    name: "Price",
    field: "price",
    type: "number_plain",
    editor: true,
    align: "right",
    object_name: "",
    object_field: "",
    table: true,
  },
  {
    name: "Product Type",
    field: "product_type",
    table: true,
    filter: true,
    editor: true,
    type: "number_plain",
    align: "right",
    object_name: "",
    object_field: "",
  },
  {
    name: "Point",
    field: "point",
    type: "number_plain",
    editor: true,
    align: "right",
    object_name: "",
    object_field: "",
    table: true,
  },
  {
    name: "Level",
    field: "level",
    table: true,
    filter: true,
    editor: true,
    type: "number_plain",
    align: "right",
    object_name: "",
    object_field: "",
  },
  {
    name: "Redeemable",
    field: "redeemable",
    align: "center",
    table: true,
    editor: true,
    type: "boolean_plain",
    filter: true,
    object_name: "",
    object_field: "",
  },
  {
    name: "Description",
    field: "description",
    type: "text_plain",
    table: false,
    filter: true,
    editor: true,
    object_name: "",
    object_field: "",
  },
  {
    name: "Benefit",
    field: "benefit",
    type: "text_plain",
    table: false,
    filter: true,
    editor: true,
    object_name: "",
    object_field: "",
  },
  {
    name: "Duration",
    field: "duration",
    type: "number_plain",
    editor: true,
    align: "right",
    object_name: "",
    object_field: "",
    table: false,
  },
];

const filterConfigs = generateFilterConfigs(configs);
const tableConfigs = generateTableConfigs(configs);

const PackageChildSelectorDialog = (props) => {
  const single = props.single ?? true;

  const {
    toast,
    listData,
    paging,
    loading,
    setListData,
    selectedRows,
    setSelectedRows,
    refineValue,
    reloadListData,
    handleOnFilter,
    handleOnPage,
    handleSelectionChange,
  } = useSelectorDialogControl({
    apiName,
    orderBy,
    orderMethod,
    additionalParams,
    visible: props.visible,
  });

  const dialogFooter = (
    <div className="col-center-center w-100">
      <Paginator
        first={paging.take * (paging.page - 1)}
        rows={paging.take}
        totalRecords={paging.total}
        rowsPerPageOptions={[5, 8, 10, 20, 50]}
        onPageChange={handleOnPage}
      />
      <div className="row-end-end w-100">
        <Button
          label="Cancel"
          icon="pi pi-times"
          outlined
          onClick={props.onHide}
        />
        <Button
          label="Pilih"
          icon="pi pi-check"
          onClick={(e) => {
            const refinedValue = refineValue(selectedRows);
            let newValue = {};
            if (refinedValue && refineValue.length >= 1) {
              newValue = {
                id: -(Math.floor(Math.random() * (9999 - 1000 + 1)) + 1000),
                child_id: refinedValue[0].id,
                data_child: refinedValue[0],
                quantity: 1,
                expired_days: 30,
              };
            }
            props.onConfirm(e, [newValue]);
          }}
        />
      </div>
    </div>
  );

  return (
    <Dialog
      visible={props.visible}
      header={title}
      modal
      className={`p-fluid w-[23rem] sm:w-[44rem] min-h-[40rem]`}
      footer={dialogFooter}
      onHide={props.onHide}
      contentStyle={{ paddingBottom: "0px" }}
    >
      <div className={`col-start-start w-100 gap-3`}>
        {filterConfigs && filterConfigs.length > 0 && (
          <FilterComponent onFilter={handleOnFilter} configs={filterConfigs} />
        )}
        <div className={`col-center-center w-100 gap-2`}>
          <TableAutoComponent
            selectable
            singleMode={single}
            selectedRows={selectedRows}
            selection={selectedRows}
            onSelectionChange={handleSelectionChange}
            configs={tableConfigs}
            loading={loading}
            value={listData}
            customColumns={customColumns}
          />
        </div>
      </div>
    </Dialog>
  );
};

export default PackageChildSelectorDialog;
